import { Component, OnDestroy, OnInit } from "@angular/core";
import { IHorizon } from "./shared/horizon";
import { HorizonsService } from "./shared/horizons.service";
import { ViewStateService } from "../shared/services/view-state.service";
import { UserService } from "../shared/services/user.service";
import * as FileSaver from "file-saver";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-horizons",
  templateUrl: "./horizons.component.html",
})
export class HorizonsComponent implements OnInit, OnDestroy {
  isInactive = true;
  private horizonsList: IHorizon[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private viewState: ViewStateService,
    private horizonsService: HorizonsService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.viewState.startLoading();
    this.isInactive = this.userService.isCurrentUserInactive;
    this.retrieveFilesList();
  }

  retrieveFilesList() {
    this.horizonsService
      .getHorizonsList()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.horizonsList = res;
          this.viewState.stopLoading();
        },
        (error) => {
          console.error(error);
          this.viewState.stopLoading();
        }
      );
  }

  retrievePDFFile(id: number) {
    this.viewState.startLoading();

    this.horizonsService
      .getHorizonsFile(id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.downloadFile(res, id);
          this.viewState.stopLoading();
        },
        (error) => {
          console.error(error);
          this.viewState.stopLoading();
        }
      );
  }

  downloadFile(stream: any, id: number) {
    const blob = new Blob([stream], { type: "application/pdf" });
    const fileName =
      this.horizonsList.find((r) => r.id === id).fileName ||
      "Horizons Newsletter";

    FileSaver.saveAs(blob, fileName);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
